namespace RedBullMOBILE360.Sms {
    export interface WhitelistExcelFile extends Serenity.ServiceRequest {
        ListName?: string;
        FileName?: string;
    }
}
